import ControlArea from "components/Layout/ControlArea";
import React, { useEffect } from "react";
import Table from "./Table";
import shareIcon from "assets/svgs/works.svg";
import { useDispatch } from "react-redux";
import { getWorks } from "store/works/actions";

const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getWorks());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <ControlArea
          btnTxt="إضافة عمل جديد"
          cardTxt="الأعمال"
          icon={shareIcon}
          url="/works/add"
        />
        <Table />
      </div>
    </>
  );
};

export default Index;
